import React, { useState } from "react";
import "./ManualDepositPopup.css";
import { IoChevronBackSharp } from "react-icons/io5";
import axios from "axios";
import { API, getUID, sendNotfication } from "../../../Helper";

function WithdrawOnline({ isOpen, onClose }) {
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState("PKR");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);


  // Withdrawal fields
  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");

  if (!isOpen) return null;


  if (success) {
    return (
      <div className="popup-overlay-inner-main-543">
        <div className="popup-container-inner-main-543">
          <div className="vip2-popup-page" style={{ background: "#323738" }}>
            Withdrawal methods
          </div>

          <div
            style={{
              background: "#232626",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "30px",
            }}
          >
            {/* Green check */}
            <div
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "50%",
                border: "3px solid #27c46b",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "15px",
              }}
            >
              <span style={{ color: "#27c46b", fontSize: "32px" }}>✓</span>
            </div>

            <div style={{ color: "#fff", fontSize: "18px", marginBottom: "5px" }}>
              Processing withdrawal
            </div>

            <div style={{ color: "#9aa4a6", fontSize: "14px", marginBottom: "25px" }}>
              This usually takes up to 4 hours
            </div>

            <button
              onClick={onClose}
              style={{
                background: "#f7ff00",
                color: "#000",
                fontWeight: "bold",
                padding: "14px",
                width: "100%",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer",
              }}
            >
              Back to game
            </button>
          </div>
        </div>
      </div>
    );
  }


  const handleSubmit = async () => {
    if (!amount || Number(amount) <= 0) {
      return sendNotfication("Enter valid amount", "danger", "bottom-left");
    }

    if (!accountNumber) {
      return sendNotfication("Account number is required", "danger", "bottom-left");
    }

    if (currency === "PKR" && !accountName) {
      return sendNotfication("Account name is required", "danger", "bottom-left");
    }

    setLoading(true);

    try {
      const payload = {
        uid: Number(getUID()),
        money: Number(amount),
        currency,
        withdrawalData:
          currency === "PKR"
            ? {
              account_number: accountNumber,
              account_name: accountName,
            }
            : {
              account_number: accountNumber,
            },
      };

      const { data } = await axios.post(
        `${API}/payment/api/withdrawal/online`,
        payload
      );

      if (!data?.status) {
        sendNotfication(data?.message || "Withdrawal failed", "danger", "bottom-left");
        return;
      }

      // sendNotfication(data.message, "success", "bottom-left");
      // onClose();
      setSuccess(true);
    } catch (error) {
      console.error(error);
      sendNotfication(error?.response?.data?.message || "Something went wrong", "danger", "bottom-left");
    } finally {
      setLoading(false);
    }
  };

  return (

    <div className="">
      <div className="popup-container-inner-main-543">


        <div
          className="main-int-overflow-sroll"
          style={{ padding: "20px", background: "#232626" }}
        >
          <div style={{ background: "#323738", padding: "20px", borderRadius: "10px" }}>
            {/* Currency */}
            <div className="main-int-uew-new-1">Withdraw Currency</div>
            <select
              className="amount-input-inner-main-543"
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
            >
              <option value="PKR">PKR</option>
              <option value="BDT">BDT</option>
              <option value="NPR">NPR</option>
            </select>

            {/* Amount */}
            <div className="main-int-uew-new-1" style={{ marginTop: "15px" }}>
              Amount
            </div>
            <input
              className="amount-input-inner-main-543"
              type="number"
              placeholder="Enter Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />

            {/* Account Number */}
            <div className="main-int-uew-new-1" style={{ marginTop: "15px" }}>
              {currency === "NPR" ? "Esewa ID" : "Account Number"}
            </div>
            <input
              className="amount-input-inner-main-543"
              type="text"
              placeholder="Enter Account Number"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
            />

            {/* Account Name (PKR only) */}
            {currency === "PKR" && (
              <>
                <div className="main-int-uew-new-1" style={{ marginTop: "15px" }}>
                  Account Name
                </div>
                <input
                  className="amount-input-inner-main-543"
                  type="text"
                  placeholder="Enter Account Name"
                  value={accountName}
                  onChange={(e) => setAccountName(e.target.value)}
                />
              </>
            )}

            <button
              disabled={loading}
              onClick={handleSubmit}
              className="submit-button-inner-main-543"
              style={{ marginTop: "20px" }}
            >
              {loading ? "Processing..." : "Submit Withdrawal"}
            </button>

            <div
              className="deposit-rules-text-12"
              style={{ background: "#314940", color: "#B3BEC1", marginTop: "20px" }}
            >
              <div>1. Withdrawal amount must match request.</div>
              <div>2. Incorrect account details may cause failure.</div>
              <div>3. Processing time depends on payment provider.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WithdrawOnline;
